<template>
  <b-modal size="lg" v-model="isShow">
    <template #modal-title>
      {{ $t('iFBlock Info') }}
    </template>
    <b-container fluid>
      <b-row class="mb-1">
        <b-col>iFBlock {{ version }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>{{ $t('Copyright (C) INDIFROG 2021') }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <span>{{ $t('Home Page') }} : </span>
        </b-col>
        <b-col cols="8">
          <b-link :href="homePage">{{ homePage }}</b-link>
        </b-col>
      </b-row>
      <hr />
      <b-row class="mb-4">
        <b-col>{{ $t('Build Date') }} : </b-col>
        <b-col cols="8">{{ buildDateString }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>{{
          $t('The Nanum font provided by Naver is applied to this page.')
        }}</b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <div class="float-right">
          <b-button variant="primary" size="sm" @click="ok">
            {{ $t('Close') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { homePage } from '@/assets/info'
import util from '@/libs/util'

export default {
  name: 'InfoPopup',
  data() {
    return {
      isShow: false,
      version: process.env.PACKAGE_VERSION,
      buildDate: process.env.PACKAGE_BUILD_DATE,
      homePage
    }
  },
  computed: {
    ...mapState(['infoPopupData']),
    buildDateString() {
      return util.date(this.buildDate)
    }
  },
  watch: {
    infoPopupData() {
      if (this.infoPopupData.isShow) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style scoped>
button.btn-danger {
  margin-right: 10px;
}
</style>
